<template>
  <div class="object-card-layout app-wrap-p-l" v-if="entity">
    <app-entity-toolbar
      class="toolbar app-wrap-p-l"
      v-on="$listeners"
      :transparent="transparent"
      :is-nested-entity="isNestedEntity"
      :current-tab="currentTabIndex"
      :tabs="entity.tabsMeta"
      :context-menu="entity.contextMenu"
      :title="entity.title"
      :entity="entity"
      :favourite="entity.favourite"
      v-scroll:#scroll-target="onScroll"
      @input="handleEntityAction($event, entity.id)"
      @close="closeCard"
      @click:back="closeNestCard"
      @change-tab="currentTabIndex = $event"
    />
    <div class="content" id="scroll-target">
      <div style="background-color: #dbdbdb;">
        <v-img
          cover
          :src="entity.image"
          height="240"
          width="100%"
          @error="isErrorLoading = true"
          v-if="!isErrorLoading && entity.image"
        >
          <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-progress-circular
                indeterminate
                color="primary lighten-2"
              ></v-progress-circular>
            </v-row>
          </template>
        </v-img>
        <v-img
          cover
          :src="entity.imageFallback"
          height="240"
          width="100%"
          v-else
        ></v-img>
      </div>
      <app-entity-header>
        <template slot="default">
          {{ entity.title }}
        </template>
        <template slot="statusbar">
          <object-statuses :entity="entity" />
        </template>
      </app-entity-header>

      <div style="position: sticky; top: 45px; z-index: 1;">
        <keep-alive>
          <app-entity-tabs
            v-if="entity.tabsMeta.length > 1"
            :is-nested-entity="isNestedEntity"
            :tabs="entity.tabsMeta"
            :current-tab="currentTabIndex"
            @change-tab="currentTabIndex = $event"
          ></app-entity-tabs>
        </keep-alive>
        <v-divider />
      </div>
      <app-entity-tab
        v-on="$listeners"
        :is-nested-entity="isNestedEntity"
        :tab-type="currentTab.type"
        :entity="entity.entity"
        :tab-data="currentTab.tabData"
      />
    </div>
  </div>
</template>

<script>
import AppEntityTabs from './EntityTabs';
import AppEntityToolbar from './AppEntityToolbar';
import AppEntityHeader from './EntityHeader';
import { computed, ref, watch } from '@vue/composition-api';
import AppEntityTab from './app-entity-tab';
import getBatteryStatus from '@/utils/getBatteryStatus';
import BatteryState from '@/components/device-states/BatteryState';
import ObjectStatuses from '@/components/device-states/ObjectStatuses';

export default {
  name: 'AppEntity',
  components: {
    ObjectStatuses,
    BatteryState,
    AppEntityTab,
    AppEntityToolbar,
    AppEntityHeader,
    AppEntityTabs
  },
  props: {
    entity: {
      type: Object,
      default: () => ({})
    },
    object: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    },
    isNestedEntity: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context) {
    const transparent = ref(true);
    const currentTabIndex = ref(0);
    const isErrorLoading = ref(false);

    const currentTab = computed(() => {
      return {
        type: props.entity.tabsMeta[currentTabIndex.value].type,
        tabData: props.entity.tabs[currentTabIndex.value]
      };
    });

    watch(
      () => props.isNestedEntity,
      () => {
        currentTabIndex.value = 0;
      }
    );

    watch(
      () => props.entity,
      () => {
        if (props.entity?.image) {
          isErrorLoading.value = false;
        }
      }
    );

    const handleEntityAction = (action, ctx) => {
      const eventPayload = {
        actionName: typeof action === 'string' ? action : action.id,
        context: ctx,
        ctxItemRaw: action?.raw,
        id: typeof ctx === 'string' ? ctx : ctx.id
      };
      context.emit('action', eventPayload);
    };

    const closeCard = () => {
      context.emit('close-card');
    };

    const closeNestCard = () => {
      context.emit('close-nested-card');
    };

    const onScroll = e => {
      transparent.value = !(e.target.scrollTop >= 260);
    };

    return {
      transparent,
      currentTabIndex,
      currentTab,
      handleEntityAction,
      closeCard,
      onScroll,
      isErrorLoading,
      closeNestCard
    };
  }
};
</script>
